// Components imports
import { getCurrencySymbol } from "./helpers";
import AppSearchBar from "./components/AppSearchBar";

// React instances
global.React = require("react");
global.ReactDOM = require("react-dom");
global.ReactDOMServer = require("react-dom/server");
global.getCurrencySymbol = getCurrencySymbol;

// Components
global.AppSearchBar = AppSearchBar;